import React from 'react';
import { ShoppingCart, Hammer, Wrench, Shield, Building2, Droplets } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: ShoppingCart,
      title: 'AC Sales',
      description: 'Wide range of air conditioning units from top brands for residential and commercial needs.',
      image: 'https://images.unsplash.com/photo-1758545814875-c2f0a0c89943'
    },
    {
      icon: Hammer,
      title: 'AC Installation',
      description: 'Professional installation services ensuring optimal performance and energy efficiency.',
      image: 'https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg'
    },
    {
      icon: Wrench,
      title: 'AC Repair',
      description: 'Quick and reliable repair services for all types of air conditioning systems.',
      image: 'https://images.pexels.com/photos/33671149/pexels-photo-33671149.jpeg'
    },
    {
      icon: Shield,
      title: 'Annual Maintenance (AMC)',
      description: 'Comprehensive maintenance contracts to keep your AC running smoothly year-round.',
      image: 'https://images.unsplash.com/photo-1610680081567-d4aa2d34cd63'
    },
    {
      icon: Building2,
      title: 'Commercial HVAC Solutions',
      description: 'Complete HVAC systems for offices, malls, and industrial facilities.',
      image: 'https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg'
    },
    {
      icon: Droplets,
      title: 'Gas Refilling & Cleaning',
      description: 'Expert gas refilling and deep cleaning services to restore cooling efficiency.',
      image: 'https://images.unsplash.com/photo-1758798157512-f0a864c696c9'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">Our Services</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Complete AC Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From sales to installation, repair, and maintenance - we provide end-to-end air conditioning services.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-xl transition-all duration-300 border-0 overflow-hidden bg-white"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm p-3 rounded-xl shadow-lg">
                  <service.icon className="text-primary" size={32} />
                </div>
              </div>
              <CardContent className="p-6 space-y-3">
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-primary transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
